
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface Meal {
  id: string;
  name: string;
  image: string;
  price: number;
  available_portions: number;
  rating: number;
  reviews_count: number;
}

interface MealsListProps {
  meals: Meal[];
  chefName: string;
}

export const MealsList = ({ meals, chefName }: MealsListProps) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4 text-black">Active Meals</h2>
      {meals.length === 0 ? (
        <p className="text-gray-500">No active meals available</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {meals.map((meal) => (
            <Link to={`/meals/${meal.id}`} key={meal.id}>
              <motion.div
                className="bg-white rounded-lg shadow-sm overflow-hidden border cursor-pointer"
                whileHover={{ y: -2 }}
              >
                <div className="h-24 overflow-hidden">
                  <img
                    src={meal.image || "https://via.placeholder.com/400x300"}
                    alt={meal.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-3 space-y-2">
                  <h3 className="font-medium text-black truncate">{meal.name}</h3>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1 text-sm text-gray-600">
                      <Star className="w-4 h-4 text-yellow-400" />
                      <span>{meal.rating ? meal.rating.toFixed(1) : "New"}</span>
                      {meal.reviews_count > 0 && (
                        <span className="text-gray-400">({meal.reviews_count})</span>
                      )}
                    </div>
                    <Badge variant="secondary">
                      ${meal.price.toFixed(2)}
                    </Badge>
                  </div>
                </div>
              </motion.div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};
